exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body {\n  padding: 25px 58px 30px 58px; }\n\n.modal-footer button {\n  margin: 0 auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/info-modal/info-modal.component.scss
// module id = ../../../../../src/app/shared/components/info-modal/info-modal.component.scss
// module chunks = main